import $ from 'jquery';
import debounce from '@/js/util/debounce';
import { onPageLoad } from '@/js/modules/page_load';

let dataTableResizeObserver;

onPageLoad(() => {
  const $standardDataTables = $('.data-table');
  const $stickyDataTables = $('.data-table-sticky-container');
  const $pageHeader = $('.header').first();

  function enableDataTableScrolling($scrollTable) {
    const scrollWidth = $scrollTable.get(0).scrollWidth;
    const innerWidth = $scrollTable.innerWidth() + 1;
    const scrollLeft = $scrollTable.scrollLeft();
    const scrollBuffer = 16;

    if (scrollWidth > innerWidth) {
      $scrollTable.addClass('data-table--with-scroll');

      if ($scrollTable.parent('.data-table-sticky-container').length) {
        $scrollTable.siblings('.data-table').addClass('data-table--with-scroll');
      }

      if (scrollLeft > scrollBuffer) {
        if (scrollLeft + innerWidth >= scrollWidth - scrollBuffer) {
          $scrollTable
            .removeClass('data-table--side-shadows data-table--right-shadow')
            .addClass('data-table--left-shadow');
        } else {
          $scrollTable
            .removeClass('data-table--right-shadow data-table--left-shadow')
            .addClass('data-table--side-shadows');
        }
      } else {
        $scrollTable
          .removeClass('data-table--side-shadows data-table--left-shadow')
          .addClass('data-table--right-shadow');
      }
    } else {
      $scrollTable.removeClass(
        'data-table--with-scroll data-table--right-shadow data-table--left-shadow data-table--side-shadows'
      );
    }
  }

  const resetDataTableScrolling = () => {
    $standardDataTables.each(function () {
      enableDataTableScrolling($(this));
    });
  };

  // Calculate heights and offsets
  const calculateHeights = ($tableBody, $tableHeader, $pageHeader) => {
    const tableHeaderHeight = $tableHeader.outerHeight();
    const tableDistance = $tableBody.offset().top - $pageHeader.outerHeight();
    const tableBodyDistance = tableDistance - tableHeaderHeight;

    return {
      tableBodyDistance,
      tableHeight: tableDistance + $tableBody.outerHeight() + tableHeaderHeight,
      tableBodyHeight: tableBodyDistance + $tableBody.outerHeight(),
      tableHeaderHeight,
    };
  };

  // Update position of sticky header
  const enableStickyDataTableHeader = ($stickyTable, heights) => {
    const { tableBodyDistance, tableHeight, tableBodyHeight, tableHeaderHeight } = heights;

    if (window.scrollY >= tableBodyDistance && window.scrollY <= tableHeight) {
      let headerEndScroll = window.scrollY - tableBodyHeight;
      if (headerEndScroll < 0) {
        headerEndScroll = 0;
      }
      $stickyTable
        .find('.data-table--sticky-head')
        .css({
          top: $pageHeader.outerHeight(),
          transform: `translateY(-${headerEndScroll}px)`,
        })
        .addClass('data-table--sticky-head-active');
      $stickyTable.find('.data-table--sticky-body').css({
        paddingTop: tableHeaderHeight,
      });
    } else {
      $stickyTable
        .find('.data-table--sticky-head')
        .css({
          top: 'auto',
          transform: 'translateY(0)',
        })
        .removeClass('data-table--sticky-head-active');
      $stickyTable.find('.data-table--sticky-body').css({
        paddingTop: '0',
      });
    }
  };

  // Update widths of cells in sticky header
  const stickyDataTableCellWidths = ($stickyTable) => {
    const $tableBody = $stickyTable.find('.data-table--sticky-body .data-table__table tbody');

    if ($tableBody.find('.data-table__tr:visible').length) {
      $stickyTable.find('.data-table--sticky-head .data-table__th').each(function (index, el) {
        const $td = $tableBody.find('.data-table__tr:visible .data-table__td').eq(index);
        const width = $td.width();
        $(el).width(width);
      });
      $stickyTable
        .find('.data-table--sticky-head .data-table__table')
        .addClass('data-table__table--fixed');
    } else {
      $stickyTable.find('.data-table--sticky-head .data-table__th').each(function (index, el) {
        $(el).width('auto');
      });
      $stickyTable
        .find('.data-table--sticky-head .data-table__table')
        .removeClass('data-table__table--fixed');
    }
  };

  $standardDataTables.on('scroll', () => {
    resetDataTableScrolling();
  });

  // The content width also changes without a window resize, e.g. when the sidenav collapses
  dataTableResizeObserver?.disconnect();
  dataTableResizeObserver = new ResizeObserver((entries) => {
    entries.forEach(({ target }) => enableDataTableScrolling($(target)));
  });
  $standardDataTables.each(function () {
    dataTableResizeObserver.observe(this);
  });

  // Synchronize horizontal scrolling of sticky table head and body
  $stickyDataTables.find('.data-table--sticky-head').on('scroll', stickyHeadScroll);
  $stickyDataTables.find('.data-table--sticky-body').on('scroll', stickyBodyScroll);

  // Add delay to reset scroll sync for Safari
  const resetStickyHeadScroll = debounce(() => {
    $stickyDataTables.find('.data-table--sticky-head').on('scroll', stickyHeadScroll);
  }, 200);
  const resetStickyBodyScroll = debounce(() => {
    $stickyDataTables.find('.data-table--sticky-body').on('scroll', stickyBodyScroll);
  }, 200);

  // Sync scroll position, unbind scroll for each section and rebind
  function stickyBodyScroll() {
    $stickyDataTables.find('.data-table--sticky-head').off('scroll', stickyHeadScroll);
    $stickyDataTables.find('.data-table--sticky-head').scrollLeft($(this).scrollLeft());
    resetStickyHeadScroll();
  }
  function stickyHeadScroll() {
    $stickyDataTables.find('.data-table--sticky-body').off('scroll', stickyBodyScroll);
    $stickyDataTables.find('.data-table--sticky-body').scrollLeft($(this).scrollLeft());
    resetStickyBodyScroll();
  }

  window.onscroll = () => {
    resetDataTableStickyHeaders();
  };

  let stickyHeights = [];
  const resetDataTableHeights = () => {
    stickyHeights = $stickyDataTables
      .map(function () {
        const $tableBody = $(this).find('.data-table--sticky-body .data-table__table');
        const $anchoredTableHeader = $(this).find('.data-table--sticky-head .data-table__table');
        return calculateHeights($tableBody, $anchoredTableHeader, $pageHeader);
      })
      .get();
  };

  // Reset position of sticky header
  const resetDataTableStickyHeaders = () => {
    resetDataTableHeights();
    $stickyDataTables.each(function (index) {
      enableStickyDataTableHeader($(this), stickyHeights[index]);
      stickyDataTableCellWidths($(this));
    });
  };

  // Single reset data table function
  const resetDataTables = () => {
    resetDataTableStickyHeaders();
    resetDataTableScrolling();
  };

  resetDataTables();

  $(window).resize(() => {
    resetDataTables();
  });

  // Sort data table columns via JS
  const sortDataTableStates = {};
  const sortDataTable = ($sortableLink) => {
    const $column = $sortableLink.closest('.data-table__th');
    const columnIndex = $column.index();
    const table = $column.closest('.data-table__table').eq(0);
    const descArrow =
      '<i trailing_icon="true" class="fa-regular fa-chevron-down fa-sm data-table__sortable-icon" aria-hidden="true"></i>';
    const ascArrow =
      '<i trailing_icon="true" class="fa-regular fa-chevron-up fa-sm data-table__sortable-icon" aria-hidden="true"></i>';
    let rows = table
      .find('tbody .data-table__tr')
      .toArray()
      .sort(compareDataTableRows(columnIndex));

    if (sortDataTableStates[columnIndex] === undefined) {
      sortDataTableStates[columnIndex] = true;
    } else {
      sortDataTableStates[columnIndex] = !sortDataTableStates[columnIndex];
    }

    table.find('.data-table__th .data-table__sortable-icon').remove();
    const sortArrow = sortDataTableStates[columnIndex] ? ascArrow : descArrow;
    $sortableLink.append(sortArrow);

    if (!sortDataTableStates[columnIndex]) {
      rows = rows.reverse();
    }

    table.children('tbody').empty().append(rows);
  };
  const compareDataTableRows = (index) => {
    return function (a, b) {
      const valA = getDataTableCellValue(a, index);
      const valB = getDataTableCellValue(b, index);

      const numA = parseDataTableCurrency(valA);
      const numB = parseDataTableCurrency(valB);

      if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB;
      } else {
        return valA.localeCompare(valB);
      }
    };
  };
  const getDataTableCellValue = (row, index) => {
    return $(row).children('.data-table__td').eq(index).text();
  };
  const parseDataTableCurrency = (val) => {
    const numericValue = parseFloat(val.replace(/[^0-9.-]+/g, ''));
    return numericValue;
  };

  $(document).on('click', '.data-table__sortable-link--js', (e) => {
    sortDataTable($(e.target));
  });
});
